import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiModule } from './core/api-client/api.module';
import { environment } from '../environments/environment';

import { provideTranslateService, provideTranslateLoader } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { ApiSetHeadersInterceptor } from './core/interceptors/api-set-headers.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { ApiBaseUrlInterceptor } from './core/interceptors/api-base-url.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimationsAsync(),
  
    provideNativeDateAdapter(),
    {
      provide: MAT_DATE_LOCALE,
      useFactory: () => localStorage.getItem('lang') === 'ro' ? 'ro-RO' : 'en-US'
    },
    // HttpClient for standalone
    provideHttpClient(withInterceptorsFromDi()), //
    { provide: HTTP_INTERCEPTORS, useClass: ApiSetHeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiBaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    // ngx-translate
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),

    // ng-openapi-gen ApiModule (so AuthApi etc. work)
    importProvidersFrom(
      ApiModule.forRoot({
        rootUrl: environment.apiBaseUrl
      })
    ),
  ]
};

